import React from "react";

const GeoCodesComp = ({ mapZoom, ...options }) => {
  const [geo, setGeo] = React.useState();

  React.useEffect(() => {
    if (!geo) {
      setGeo(
        new window.google.maps.Polygon({
          paths: [],
          strokeColor: "#000000",
          strokeOpacity: 0.8,
          strokeWeight: 1,
          fillOpacity: 0.25,
        })
      );
    }

    // remove geo from map on unmount
    return () => {
      if (geo) {
        if (window.google) {
          geo.setMap(null);
        }
      }
    };
  }, [geo]);

  React.useEffect(() => {
    if (geo && options) {
      geo.setOptions({
        paths: options.coords,
        strokeColor: options.color,
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: options.color, // "#999999",
        fillOpacity: 0.25,
        map: options.map,
      });
    }
  }, [geo, options]); //, onIdle,onZoomChanged, onClick,
};

export default React.memo(GeoCodesComp);
